import React, { useState, useEffect } from 'react';
import bookCover1 from '../assets/images/book1.png';
import glossary from '../assets/books/Биржевой глоссарий.pdf';
import { BookOpenIcon, LockClosedIcon } from '@heroicons/react/24/solid';
import { useTranslations } from '../hooks/useTranslations';

function Glossary() {
  const { t } = useTranslations();
  const [userData, setUserData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const glossaryBook = {
    id: 1,
    title: t('glossary.title'),
    description: t('glossary.description'),
    pdfPath: glossary
  };

  useEffect(() => {
    const fetchUserData = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setIsLoading(false);
        return;
      }
      try {
        const response = await fetch("https://api.maxprofitacademy.com/user", {
          method: "GET",
          headers: { "token": JSON.parse(token) }
        });
        const data = await response.json();
        if (data.status === 200) {
          setUserData(data.data);
        }
      } catch (error) {
        //
      } finally {
        setIsLoading(false);
      }
    };
    fetchUserData();
  }, []);

  const hasValidCourse = userData?.course && ['GOLD', 'SILVER', 'PLATINUM'].includes(userData.course.toUpperCase());

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
        <span className="ml-3 text-gray-600">{t('glossary.loading')}</span>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
      <div className="bg-white rounded-3xl p-6 flex shadow-sm hover:shadow-md transition-shadow">
        <div className="md:w-1/3 w-20 flex items-center justify-center">
          <div className="bg-primary/10 p-4 rounded-xl">
            <BookOpenIcon className="w-full h-full text-primary" />
          </div>
        </div>
        <div className="w-2/3 pl-6 flex flex-col">
          <h3 className="md:text-xl text-base font-semibold mb-2 text-black">{glossaryBook.title}</h3>
          <p className="text-gray-600 md:text-sm text-xs flex-grow">{glossaryBook.description}</p>
          {hasValidCourse ? (
            <a
              href={glossaryBook.pdfPath}
              download
              className="mt-4 flex items-center text-[12px] md:text-[18px] justify-center space-x-2 bg-primary text-black px-4 py-2 rounded-xl hover:bg-primary/90 transition-colors"
            >
              <BookOpenIcon className="w-5 h-5" />
              <span>{t('glossary.downloadPdf')}</span>
            </a>
          ) : (
            <button
              className="mt-4 flex items-center text-[12px] md:text-[18px] justify-center space-x-2 bg-gray-100 text-gray-500 px-4 py-2 rounded-xl hover:bg-gray-200 transition-colors"
              disabled
            >
              <LockClosedIcon className="w-5 h-5" />
              <span>{t('glossary.unavailable')}</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default Glossary; 